'use strict';
const angular = require('angular');

export class iframePreviewComponent {
  /*@ngInject*/
  constructor() {
  }

  $onInit() {
    this.config = this.resolve.config;
    this.content = this.config.content;
  };

  ok() {
    this.cancel();
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

}

export default angular.module('conduApp.iframePreview', [])
  .component('iframePreview', {
    template: require('./iframe-preview.component.html'),
    bindings: {
      resolve: '<',
      dismiss: '&'
    },
    controller: iframePreviewComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/iframe-preview/iframe-preview.component.js